import { render, staticRenderFns } from "./IGTProductBundleBuilder.vue?vue&type=template&id=c99e53a0&scoped=true&"
import script from "./IGTProductBundleBuilder.vue?vue&type=script&lang=js&"
export * from "./IGTProductBundleBuilder.vue?vue&type=script&lang=js&"
import style0 from "./IGTProductBundleBuilder.vue?vue&type=style&index=0&id=c99e53a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99e53a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99e53a0')) {
      api.createRecord('c99e53a0', component.options)
    } else {
      api.reload('c99e53a0', component.options)
    }
    module.hot.accept("./IGTProductBundleBuilder.vue?vue&type=template&id=c99e53a0&scoped=true&", function () {
      api.rerender('c99e53a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/IGTProductBundleBuilder.vue"
export default component.exports